<div class="pb-2 layout" *ngIf="!configurationMode && layout && deviceViews.length > 0">
    <button *ngIf="!showLayout" mat-raised-button color="sims" (click)="open()" class="mr-1">
        {{ 'diagram' | translate}}
    </button>
    <div class="mb-1 space"></div>
    <div *ngIf="showLayout">
        <div class="grid-container {{layout.layoutType}} mt-2 mb-4 mr-auto ml-auto p-2 pb-3">
            <ng-container *ngFor="let location of displayedLocations">
                <div [ngClass]="isClicked ? 'clicked' : ''"
                    class="{{location.locationName}} location {{layout.layoutType}}_layout {{editableMode ? 'editable' : ''}}"
                    (click)="onClicked(location)" fxLayout="row wrap" fxLayoutAlign="space-around center">
                    <span class="device" *ngFor="let device of location.devices" fxFlex="30">
                        <mat-icon class="{{device.deviceType}} {{checkError(device)}}" svgIcon="device_location">
                        </mat-icon>
                    </span>
                </div>
            </ng-container>
        </div>
        <button mat-raised-button color="sims" (click)="showLayout = false" class="mr-1">
            {{ 'hide' | translate}}
        </button>
        <app-device-filter #filter [displayedLocations]="displayedLocations" [singleLocation]="singleLocation"
            (filterLayout)="filterDisplayedDevices($event)"></app-device-filter>
    </div>
</div>
<div class="pb-2 layout" *ngIf="configurationMode">
    <div class="mb-1 space"></div>
    <div *ngIf="showLayout">
        <div class="grid-container {{layout.layoutType}} mt-2 mb-4 mr-auto ml-auto p-2 pb-3">
            <ng-container *ngFor="let location of displayedLocations">
                <div [ngClass]="isClicked ? 'clicked' : ''"
                    class="{{location.locationName}} location {{layout.layoutType}}_layout {{editableMode ? 'editable' : ''}}"
                    (click)="onClicked(location)" fxLayout="row wrap" fxLayoutAlign="space-around center"
                    [id]="location.locationName"
                    cdkDropList
                    [cdkDropListData]="location.locationName"
                    (cdkDropListDropped)="dropDevice($event)"
                    [cdkDropListConnectedTo]="['delete']">
                    <span class="device" *ngFor="let device of location.devices; let i = index" fxFlex="30">
                        <mat-icon class="{{device.deviceType}} " svgIcon="device_location"
                            matTooltip="{{findDeviceKey(device.deviceType, i, location.locationName) | translate}}"
                            [cdkDragData]="{deviceType: device.deviceType, locationName: location.locationName, index: i}" cdkDrag>
                        </mat-icon>
                    </span>
                </div>
            </ng-container>
        </div>
        <app-device-filter #filter [displayedLocations]="displayedLocations" [configurationMode]="configurationMode"
            (filterLayout)="filterDisplayedDevices($event)"></app-device-filter>
    </div>
</div>